import React, { useEffect } from 'react'
import { Button } from '@chakra-ui/react'
import { useAuth, useLogout } from 'hooks/auth'
import { PROTECTED, USERS } from 'lib/routes';
import { Link, useNavigate } from 'react-router-dom';
import Avatar from './Avatar';
import 'stylesheets/MainAppStyles/profile.css'
import SpinnerLoading from '../Spiners';


function ActiveUser() {
    const { user, isLoading } = useAuth();
    const navigate = useNavigate()
    if (isLoading) return "Loading..."
    navigate(`${PROTECTED}/profile/${user.id}`)
    return (
        <>
            {/* <Avatar user={user} />
            <h1 className='name'>{user.name} {user.lastname}</h1>
            <h2 className='username'>@{user.username}</h2>
            <Button
                className='button'
                colorScheme='teal'
                as={Link}
                to={`${PROTECTED}/profile/${user.id}`}
            >Edit Profile</Button> */}
        </>
    )
}


const Profile = () => {
    const { logout, isLoading } = useLogout();
    const { user, isLoading: userLoading } = useAuth();
    const navigate = useNavigate()
    useEffect(() => {
        if (!userLoading) {
            navigate(`${PROTECTED}/profile/${user.id}`)
        }
    }, [userLoading])

    if (userLoading) return <SpinnerLoading />
    return (
        <>
        </>
        // <div className='profile-main-container'>
        //     <div className="profile-container">
        //         <ActiveUser />
        //         <div className='main-buttons'></div>
        //         {/* <Button
        //             variant="outline"
        //             colorScheme="teal"
        //             as={Link}
        //             to={USERS}
        //             className='button'
        //         >ALL USERS</Button> */}
        //         <Button
        //             colorScheme='teal'
        //             onClick={logout}
        //             isLoading={isLoading}
        //             className='button'
        //         >Logout
        //         </Button>
        //     </div>
        // </div >
    )
}

export default Profile